import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Tạo curl command từ thông tin request
 * Tự động sanitize sensitive headers (Authorization, Cookie, etc.)
 */
export function generateCurlCommand(
  method: string,
  url: string,
  headers?: Record<string, string>,
  body?: unknown
): string {
  const curlParts = [`curl -X ${method}`];

  // Thêm headers (sanitize sensitive headers)
  if (headers) {
    Object.entries(headers).forEach(([key, value]) => {
      const lowerKey = key.toLowerCase();

      // Sanitize sensitive headers để không expose token
      if (
        lowerKey === 'authorization' ||
        lowerKey === 'cookie' ||
        lowerKey === 'x-api-key' ||
        lowerKey === 'x-auth-token'
      ) {
        curlParts.push(`-H "${key}: [REDACTED]"`);
      } else {
        curlParts.push(`-H "${key}: ${value}"`);
      }
    });
  }

  // Thêm body nếu có
  if (body !== undefined && body !== null) {
    if (typeof body === 'string') {
      curlParts.push(`-d '${body}'`);
    } else {
      curlParts.push(`-d '${JSON.stringify(body)}'`);
    }
  }

  // Thêm URL
  curlParts.push(`"${url}"`);

  return curlParts.join(' \\\n  ');
}
